import { NavItem } from 'common/HorizontalNavPage';
import { useUserManagementIntl } from './translations/useUserManagementIntl';

export enum USER_MANAGEMENT_TABS {
  GENERAL = 'general',
  USERS = 'users',
  TASK_DELEGATION = 'task-delegation'
}

export const useGetNavItems = () => {
  const intl = useUserManagementIntl();

  const navItems: NavItem[] = [
    {
      label: intl.general,
      path: USER_MANAGEMENT_TABS.GENERAL,
      'data-test': 'user-management-general',
      permissions: [{ name: 'USER', action: 'READ' }]
    },
    {
      label: intl.usersHeader,
      path: USER_MANAGEMENT_TABS.USERS,
      'data-test': 'user-management-users',
      permissions: [{ name: 'USER', action: 'READ' }]
    },
    {
      label: intl.taskDelegationHeader,
      path: USER_MANAGEMENT_TABS.TASK_DELEGATION,
      'data-test': 'user-management-task-delegation',
      permissions: [{ name: 'TASK_DELEGATION', action: 'READ' }]
    }
  ];

  return {
    navItems
  };
};
